// Library Import
import {
  Box,
  Flex,
  Button,
  Stack,
  Image,
  useBoolean,
  Icon,
  useColorMode,
  useColorModeValue,
  Badge,
} from "@chakra-ui/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Icon Imports
import { FaPlay } from "react-icons/fa";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";

// Local Imports
import {
  redSetUserDetails,
  redUserSliceLoading,
  redUserSliceNotLoding,
  redSetLogout,
} from "../redux/slices/userSlice";
import intelLogo from "../assets/intelIq.png";

export default function Navbar({ active, onOpen }) {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { colorMode, toggleColorMode } = useColorMode();

  const [mobileMode, setMobileMode] = useBoolean();
  const [isLoggedIn, setIsLoggedIn] = useBoolean();

  const { userDetails } = useSelector((state) => state.stateUserReducer);

  useEffect(() => {
    if (window.innerWidth < 450) {
      setMobileMode.on();
    } else {
      setMobileMode.off();
    }
  }, [userDetails, window.innerWidth]);

  return (
    <>
      {active === "ChallengeScreen" && (
        <Box
          bg={useColorModeValue("gray.100", "gray.700")}
          px={5}
          width="100%"
          zIndex="10"
        >
          <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
            <Image
              src={
                "https://ik.imagekit.io/bghodwh4h/fav.png?updatedAt=1760447517555"
              }
              alt="Intel IQ"
              width="120px"
              mt={"5px"}
            />

            <Flex alignItems={"center"} gap={4}>
              {/* <Button
                leftIcon={<Icon as={FaPlay} />}
                colorScheme="black"
                variant="ghost"
                size="sm"
                onClick={onOpen}
                _hover={{
                  bg: "blue.50",
                }}
              >
                How It Works
              </Button> */}

              {/* <Button
                onClick={toggleColorMode}
                size="md"
                variant="ghost"
                _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
              >
                {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
              </Button> */}

              <Stack direction={"row"} spacing={5}>
                {userDetails && (
                  <Button
                    colorScheme="red"
                    width={{ base: "70px", md: "90px" }}
                    fontSize={{ base: "15px", md: "17px" }}
                    onClick={() => {
                      dispatch(redSetLogout());
                    }}
                  >
                    Log Out
                  </Button>
                )}
              </Stack>
            </Flex>
          </Flex>
        </Box>
      )}
      {active === "TestScreen" && (
        <Box
          bg={useColorModeValue("gray.100", "gray.700")}
          px={4}
          width="100%"
          zIndex="10"
        >
          <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
            <Image
              src={
                "https://ik.imagekit.io/bghodwh4h/fav.png?updatedAt=1760447517555"
              }
              alt="Intel IQ"
              width="120px"
              mt={"5px"}
            />

            <Flex alignItems={"center"} gap={4}>
              <Badge colorScheme="black" fontSize={"15px"}>
                {userDetails?.name}
              </Badge>
              <Badge colorScheme="black" fontSize={"15px"}>
                {userDetails?.email}
              </Badge>

              <Stack direction={"row"} spacing={5}>
                {userDetails && (
                  <Button
                    colorScheme="red"
                    width={{ base: "70px", md: "90px" }}
                    fontSize={{ base: "15px", md: "17px" }}
                    onClick={() => {
                      dispatch(redSetLogout());
                    }}
                  >
                    Log Out
                  </Button>
                )}
              </Stack>
            </Flex>
          </Flex>
        </Box>
      )}
    </>
  );
}
